
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GRAPHQL_API } from "@/graphql/GraphqlAPI";
import { Workspace, Decision } from "@/graphql/API";
import { getModule } from "vuex-module-decorators";
import { mixins } from "vue-class-component";
import PermissionCheck from "@/components/mixins/PermissionCheck";
import Workspaces from "@/store/modules/Workspaces";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import Viewpoints from "@/store/modules/Viewpoints";
import Apps from "@/store/modules/Apps";
import Factors from "@/store/modules/Factors";
import ViewWrapper from "@/components/ui/ViewWrapper.vue";
import FullPageMessage from '@/components/ui/FullPageMessage.vue';
import AccessDenied from "@/components/users/AccessDenied.vue";

const workspaceModule = getModule(Workspaces);
const decisionModule = getModule(Decisions);
const appsModule = getModule(Apps);
const choicesModule = getModule(Choices);
const viewpointsModule = getModule(Viewpoints);
const factorsModule = getModule(Factors);

@Component({
    components: {
        ViewWrapper,
        FullPageMessage,
        AccessDenied,
    },
})
export default class FrameworkImportView extends mixins(PermissionCheck) {
    @Prop()
    header!: string;

    @Prop()
    bannerImage!: string;

    @Prop()
    bannerAlign!: string;

    private selectWorkspaceId: number | null = null;
    private selectDecisionId: number | null = null;
    private decisionList: Decision[] = [];
    private loadingDecisions = false;
    private copyingFramework = false;
    private copyDone = false;
    private copyError = false;
    private fetchError = false;

    get selectedWorkspaceId(): number | null {
        return workspaceModule.selectedWorkspaceId;
    }

    get workspaceList(): Workspace[] {
        return workspaceModule.workspaceList;
    }

    get currSelectedDecisionId(): number | null {
        return decisionModule.selectedDecisionId;
    }

    private mounted() {
        this.selectWorkspaceId = this.selectedWorkspaceId;
    }

    private async importFramework(): Promise<void> {
        if (
            this.selectWorkspaceId &&
            this.selectDecisionId &&
            this.currSelectedDecisionId
        ) {
            this.copyingFramework = true;
            try {
                await decisionModule.copyDecisionInto({
                    source_d_id: this.selectDecisionId,
                    dest_d_id: this.currSelectedDecisionId,
                    app_suffix: "",
                });
                await Promise.all([
                    appsModule.getApps(this.currSelectedDecisionId),
                    choicesModule.fetchChoices(this.currSelectedDecisionId),
                    viewpointsModule.fetchViewpoints(this.currSelectedDecisionId),
                    factorsModule.fetchRootFactors(this.currSelectedDecisionId),
                ]);
                this.copyDone = true;
            } catch {
                this.copyError = true;
            }
            this.copyingFramework = false;
        }
    }

    @Watch("selectWorkspaceId")
    private async onChangeWorkspaceId(val: number): Promise<void> {
        if (val) {
            this.selectDecisionId = null;
            this.loadingDecisions = true;
            try {
                this.decisionList = await GRAPHQL_API.fetchDecisions(val);
                this.fetchError = false;
            } catch {
                this.fetchError = true;
            }

            this.loadingDecisions = false;
        }
    }
}
